var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgTrophyRed = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.02637 21.2301C7.02637 20.2453 7.41756 19.3009 8.11388 18.6046C8.8102 17.9083 9.75461 17.5171 10.7394 17.5171C11.7241 17.5171 12.6685 17.9083 13.3648 18.6046C14.0612 19.3009 14.4524 20.2453 14.4524 21.2301H7.02637Z",
    stroke: "#08081B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.02637 21.2301C7.02637 20.2453 7.41756 19.3009 8.11388 18.6046C8.8102 17.9083 9.75461 17.5171 10.7394 17.5171C11.7241 17.5171 12.6685 17.9083 13.3648 18.6046C14.0612 19.3009 14.4524 20.2453 14.4524 21.2301H7.02637Z",
    stroke: "#E60000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5509 1L15.0949 9.77681C14.3865 12.954 12.8028 13.4056 10.6426 13.4056C8.48244 13.4056 6.90298 12.954 6.1904 9.77681L4.73438 1H16.5509Z",
    stroke: "#08081B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5509 1L15.0949 9.77681C14.3865 12.954 12.8028 13.4056 10.6426 13.4056C8.48244 13.4056 6.90298 12.954 6.1904 9.77681L4.73438 1H16.5509Z",
    stroke: "#E60000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6426 13.4058V17.5157",
    stroke: "#08081B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6426 13.4058V17.5157",
    stroke: "#E60000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5506 1H20.2846C20.2846 1 19.9634 5.50132 18.5943 6.87178C17.0514 8.41477 15.4326 7.73866 15.4326 7.73866",
    stroke: "#08081B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5506 1H20.2846C20.2846 1 19.9634 5.50132 18.5943 6.87178C17.0514 8.41477 15.4326 7.73866 15.4326 7.73866",
    stroke: "#E60000",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.73263 1H1C1 1 1.31982 5.50132 2.68326 6.87178C4.22625 8.41477 5.84499 7.73866 5.84499 7.73866",
    stroke: "#08081B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M4.73263 1H1C1 1 1.31982 5.50132 2.68326 6.87178C4.22625 8.41477 5.84499 7.73866 5.84499 7.73866",
    stroke: "#E60000",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTrophyRed);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/TrophyRed.edcc66de1f4e636bbb34498a81c6ac2e.svg";